var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Gym Diary")]),(_vm.userInfo.name)?_c('h2',[_c('span',[_vm._v("for")]),_vm._v(" "+_vm._s(_vm.userInfo.name))]):_vm._e(),_c('span',[_vm._v("Version "+_vm._s(_vm.$storage.version))])])}
var staticRenderFns = []

export { render, staticRenderFns }